// copied from https://codesandbox.io/embed/material-ui-cascading-menu-fvsl4

import React from 'react';
import { PropTypes } from 'prop-types';
import { Settings } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import CascadingMenu from '../CascadingMenu/CascadingMenu';
import { withTranslation } from 'react-i18next';
import { languageMenu, brandMenu, visMenu } from '.';

class TestNativeFeatures extends React.PureComponent {
  menuItems = [];

  constructor(props) {
    super(props);
    this.state = {
      anchorElement: null,
      selectedLang: 'en',
    };
    this.menuItems.push(languageMenu(this.props.t), brandMenu, visMenu);
  }

  /**
   * @name render
   * @description react component render
   */
  render() {
    const { anchorElement } = this.state;

    return (
      <React.Fragment>
        <IconButton
          aria-label="Toggle User Menu"
          aria-controls="user-menu"
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          <Settings />
        </IconButton>
        <CascadingMenu
          anchorElement={anchorElement}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          menuItems={this.menuItems}
          onClose={this.handleClose}
          open={Boolean(anchorElement)}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        />
      </React.Fragment>
    );
  }

  /**
   * @name handleClick
   * @description handle Click on Menu Root(Settings) icon
   */
  handleClick = event => this.setState({ anchorElement: event.currentTarget });

  /**
   * @name handleClose
   * @description handle menu close event
   */
  handleClose = () => this.setState({ anchorElement: null });
}

TestNativeFeatures.propTypes = {
  t: PropTypes.func.isRequired,
};
export default withTranslation()(TestNativeFeatures);
